"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionsManager = void 0;
const functions_1 = require("firebase/functions");
/**
 * Functions Service Manager
 * Handles Firebase Cloud Functions initialization
 */
class FunctionsManager {
    constructor(region = 'us-central1') {
        this.functions = null;
        this.initialized = false;
        this.region = region;
    }
    initialize(app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initialized && this.functions) {
                return this.functions;
            }
            try {
                console.log(`⚡ FunctionsManager: Initializing Firebase Functions (${this.region})...`);
                this.functions = (0, functions_1.getFunctions)(app, this.region);
                this.initialized = true;
                console.log('✅ FunctionsManager: Functions service initialized');
                return this.functions;
            }
            catch (error) {
                console.error('❌ FunctionsManager: Failed to initialize Functions:', error);
                throw error;
            }
        });
    }
    getInstance() {
        return this.functions;
    }
    getFunctions() {
        if (!this.functions) {
            throw new Error('Functions not initialized. Call initialize() first.');
        }
        return this.functions;
    }
    isInitialized() {
        return this.initialized && this.functions !== null;
    }
    /**
     * Reset manager for testing purposes
     */
    reset() {
        this.functions = null;
        this.initialized = false;
    }
}
exports.FunctionsManager = FunctionsManager;
